import React, { FC } from 'react';
import { useTheme } from '@mui/material';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { GridRowId, useGridApiContext } from '@mui/x-data-grid-pro';

import { ITimeCategoryBaseDTO } from 'src/api/dtos';
import { ChevronDownIcon } from 'src/shared/components';

interface Props {
  id: GridRowId;
  field: string;
  absenceAndOverride: ITimeCategoryBaseDTO | null;
  isEdited: boolean;
}

export const TimesheetAbsenceOverrideViewCell: FC<Props> = ({ id, field, absenceAndOverride, isEdited }) => {
  const theme = useTheme();
  const apiRef = useGridApiContext();
  const label = absenceAndOverride?.description;

  const handleCellClick = () => {
    apiRef.current.startCellEditMode({ id, field });
  };

  return (
    <Stack
      width="100%"
      height="100%"
      justifyContent="center"
      alignItems="center"
      padding="0 8px"
      sx={{
        background: (theme) =>
          isEdited
            ? `${theme.palette.mode === 'dark' ? theme.palette.secondary.dark : theme.palette.secondary.main}`
            : 'initial',
      }}
      onClick={handleCellClick}
    >
      {label ? (
        <Typography fontSize="0.875rem" overflow="hidden" whiteSpace="nowrap" textOverflow="ellipsis" title={label}>
          {label}
        </Typography>
      ) : (
        <ChevronDownIcon color={theme.palette.text.secondary} style={{ marginLeft: 'auto' }} />
      )}
    </Stack>
  );
};
